import React from 'react';
var Carte = function (_a) {
    var children = _a.children, isHorizontal = _a.isHorizontal, ratioHorizontal = _a.ratioHorizontal, taille = _a.taille, hasFondGris = _a.hasFondGris, hasFondTransparent = _a.hasFondTransparent, noBordure = _a.noBordure, hasOmbrePortee = _a.hasOmbrePortee, noEnlargeLink = _a.noEnlargeLink;
    var classCard = "fr-card";
    if (!noEnlargeLink) {
        classCard += " fr-enlarge-link";
    }
    if (isHorizontal) {
        classCard += " fr-card--horizontal";
        if (ratioHorizontal) {
            classCard += " fr-card--horizontal-" + ratioHorizontal;
        }
    }
    if (taille) {
        if (taille !== 'md') {
            classCard += " fr-card--" + taille;
        }
    }
    if (hasFondGris) {
        classCard += " fr-card--grey";
    }
    if (hasFondTransparent) {
        classCard += " fr-card--no-background";
    }
    if (noBordure) {
        classCard += " fr-card--no-border";
    }
    if (hasOmbrePortee) {
        classCard += " fr-card--shadow";
    }
    return (React.createElement("div", { className: classCard }, children));
};
export default Carte;
